module.exports = __webpack_public_path__ + "static/img/08.7c66b003.jpg";